export default class SDARelateDA {
    constructor(data = {}) {
        this.Hmerom = data.Hmerom || null
        this.NumberPar = data.NumberPar || null
        this.User_ID = data.User_ID || null
        this.qrURL = data.qrURL || ''
        this.invoiceMark = data.invoiceMark || ''
        this.Posot = data.Posot || 0
        this.PartnerBrandName = data.PartnerBrandName || ''
        this.BranchAddress = data.BranchAddress || ''
        this.ProjectName = data.ProjectName || ''
    }
} 